var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configurator-container"},[_c('section',{staticClass:"configurator"},[_c('BunSelector'),_c('BunCanvas'),_c('OptionFilter')],1),_c('section',{staticClass:"recipes"},[_c('recipe-list')],1),_c('Loader'),_c('ContactForm'),_c('ModalCover')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }